<h2 mat-dialog-title>Filtros Avançados</h2>
<mat-dialog-content>
  <div class="filtro-section">
    <h4>Categorias</h4>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Selecionar categorias</mat-label>
      <mat-select multiple [formControl]="categoriasCtrl">
        @for (item of categorias; track item.id) {
          <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="divider"></div>

  <div class="filtro-section">
    <h4>Tags</h4>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Selecionar tags</mat-label>
      <mat-select multiple [formControl]="tagsCtrl">
        @for (item of tags; track item.id) {
          <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="divider"></div>

  <div class="filtro-section">
    <h4>Situação</h4>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Selecionar situação</mat-label>
      <mat-select [formControl]="situacaoCtrl">
        @for (situacao of situacoes; track situacao) {
          <mat-option [value]="situacao">{{ getSituacaoLabel(situacao) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="limpar()">Limpar filtros</button>
  <button mat-stroked-button class="btn-secondary" type="button" mat-dialog-close>Cancelar</button>
  <button mat-flat-button class="btn-primary" type="button" (click)="aplicar()">Aplicar filtros</button>
</mat-dialog-actions>
